import { actionCreator } from 'utils';
import * as LogisticTypes from '../types/logisticTypes';

// L O A D   L O G I S T I C
export function loadLogistic() {
    return {
        type: LogisticTypes.LOAD_LOGISTIC,
    };
}

export function loadLogisticRes(data) {
    return {
        type: actionCreator(LogisticTypes.LOAD_LOGISTIC, 'res'),
        data,
    };
}

export function loadLogisticErr() {
    return {
        type: actionCreator(LogisticTypes.LOAD_LOGISTIC, 'err'),
    };
}

export function setLogisticNeededData(data) {
    return {
        type: LogisticTypes.SET_LOGISTIC_NEEDED_DATA,
        data,
    };
}
// L O A D   L O G I S T I C

// S E T   L O G I S T I C   F I L T E R S
export function setLogisticFilters(key, value) {
    return {
        type: LogisticTypes.SET_LOGISTIC_FILTERS,
        key,
        value,
    };
}
// S E T   L O G I S T I C   F I L T E R S

// R E S E T   L O G I S T I C   F I L T E R S
export function resetLogisticFilters() {
    return {
        type: LogisticTypes.RESET_LOGISTIC_FILTERS,
    };
}
// R E S E T   L O G I S T I C   F I L T E R S

// S E T   L O G I S T I C   P A G I N A T I O N
export function setLogisticPagination(key, pagination) {
    return {
        type: LogisticTypes.SET_LOGISTIC_PAGINATION,
        key,
        pagination,
    };
}
// S E T   L O G I S T I C   P A G I N A T I O N

// S E T   C H E C K E D   L O G I S T I C
export function setCheckedLogistic(id) {
    return {
        type: LogisticTypes.SET_CHECKED_LOGISTIC,
        id,
    };
}
// S E T   C H E C K E D   L O G I S T I C

// S E T   L O G I S T I C   C O M M E N T
export function setLogisticComment(data) {
    return {
        type: LogisticTypes.SET_LOGISTIC_COMMENT,
        data,
    };
}
export function setLogisticCommentRes(loading, success) {
    return {
        type: actionCreator(LogisticTypes.SET_LOGISTIC_COMMENT, 'res'),
        loading,
        success,
    };
}

export function setLogisticCommentErr(error) {
    return {
        type: actionCreator(LogisticTypes.SET_LOGISTIC_COMMENT, 'err'),
        error,
    };
}
// S E T   L O G I S T I C   C O M M E N T

// S T O P   L O G I S T I C   I T E M
export function simplePrintLabel(data) {
    return {
        type: LogisticTypes.SIMPLE_PRINT_LABEL,
        data,
    };
}

export function simplePrintLabelRes() {
    return {
        type: actionCreator(LogisticTypes.SIMPLE_PRINT_LABEL, 'res'),
    };
}

export function simplePrintLabelErr() {
    return {
        type: actionCreator(LogisticTypes.SIMPLE_PRINT_LABEL, 'err'),
    };
}
// S T O P   L O G I S T I C   I T E M

// B U L K   S T O P   L O G I S T I C   I T E M
export function printGroupedLabel(data) {
    return {
        type: LogisticTypes.PRINT_GROUPED_LABEL,
        data,
    };
}

export function printGroupedLabelRes() {
    return {
        type: actionCreator(LogisticTypes.PRINT_GROUPED_LABEL, 'res'),
    };
}

export function printGroupedLabelErr() {
    return {
        type: actionCreator(LogisticTypes.PRINT_GROUPED_LABEL, 'err'),
    };
}
// B U L K   S T O P   L O G I S T I C   I T E M

// S E T   P R I N T   L A B E L   P O P U P
export function setPrintLabelPopup(data) {
    return {
        type: LogisticTypes.SET_PRINT_LABEL_POPUP,
        data,
    };
}
// S E T   P R I N T   L A B E L   P O P U P

// S E T   S U B M I T T I N G
export function setSubmitting(data) {
    return {
        type: LogisticTypes.SET_SUBMITTING,
        data,
    };
}
// S E T   S U B M I T T I N G


// S E N D   D E M A N D   C O N V O C A T I O N   T N T
export function sendDemandConvocationTNT(data) {
    return {
        type: LogisticTypes.SEND_DEMAND_CONVOCATION_TNT,
        data,
    };
}

export function sendDemandConvocationTNTRes() {
    return {
        type: actionCreator(LogisticTypes.SEND_DEMAND_CONVOCATION_TNT, 'res'),
    };
}

export function sendDemandConvocationTNTErr() {
    return {
        type: actionCreator(LogisticTypes.SEND_DEMAND_CONVOCATION_TNT, 'err'),
    };
}
// S E N D   D E M A N D   C O N V O C A T I O N   T N T


// T N T   D O C U M E N T S
export function loadTNTDocuments() {
    return {
        type: LogisticTypes.LOAD_TNT_DOCUMENTS,
    };
}

export function loadTNTDocumentsRes(data) {
    return {
        type: actionCreator(LogisticTypes.LOAD_TNT_DOCUMENTS, 'res'),
        data,
    };
}

export function loadTNTDocumentsErr() {
    return {
        type: actionCreator(LogisticTypes.LOAD_TNT_DOCUMENTS, 'err'),
    };
}

export function setTNTDocumentsFilters(key, value) {
    return {
        type: LogisticTypes.SET_TNT_DOCUMENTS_FILTERS,
        key,
        value,
    };
}

export function resetTNTDocumentsFilters() {
    return {
        type: LogisticTypes.RESET_TNT_DOCUMENTS_FILTERS,
    };
}

export function setTNTDocumentsPagination(key, pagination) {
    return {
        type: LogisticTypes.SET_TNT_DOCUMENTS_PAGINATION,
        key,
        pagination,
    };
}
// T N T   D O C U M E N T S


// D E L E T E   L O G I S T I C   L A B E L
export function deleteLogisticLabel(data) {
    return {
        type: LogisticTypes.DELETE_LOGISTIC_LABEL,
        data,
    };
}

export function deleteLogisticLabelRes() {
    return {
        type: actionCreator(LogisticTypes.DELETE_LOGISTIC_LABEL, 'res'),
    };
}

export function deleteLogisticLabelErr() {
    return {
        type: actionCreator(LogisticTypes.DELETE_LOGISTIC_LABEL, 'err'),
    };
}
// D E L E T E   L O G I S T I C   L A B E L

// T N T   L A B E L
export function loadTNTLabel() {
    return {
        type: LogisticTypes.LOAD_TNT_LABEL,
    };
}

export function loadTNTLabelRes(data) {
    return {
        type: actionCreator(LogisticTypes.LOAD_TNT_LABEL, 'res'),
        data,
    };
}

export function loadTNTLabelErr() {
    return {
        type: actionCreator(LogisticTypes.LOAD_TNT_LABEL, 'err'),
    };
}

export function setTNTLabelFilters(key, value) {
    return {
        type: LogisticTypes.SET_TNT_LABEL_FILTERS,
        key,
        value,
    };
}

export function resetTNTLabelFilters() {
    return {
        type: LogisticTypes.RESET_TNT_LABEL_FILTERS,
    };
}

export function setTNTLabelPagination(key, pagination) {
    return {
        type: LogisticTypes.SET_TNT_LABEL_PAGINATION,
        key,
        pagination,
    };
}
// T N T   L A B E L
